module.exports = {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#search",
      toString: function () {
        return this.url;
      }
    }